/**
 * Format a phone number for display.
 * Handles common US formats: 10-digit, 11-digit with country code.
 * Returns the original string if it doesn't match known patterns.
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  // Return original if unrecognized format (international, extensions, etc.)
  return phone;
}

/**
 * Format a time-only string (HH:MM:SS or HH:MM) to 12-hour format.
 * "09:00:00" → "9:00 AM", "14:30" → "2:30 PM"
 * Returns the original string if it doesn't match HH:MM[:SS] pattern.
 */
export function formatTimeString(time: string | null | undefined): string {
  if (!time) return "";
  const match = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(time.trim());
  if (!match) return time;
  const hour = parseInt(match[1], 10);
  const minutes = match[2];
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
}
